import React from 'react';
import { render, hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import store from './store';
import { fetchConfig, sniffAgent } from './actions';
import App from 'components/App';
import { UAParser } from 'ua-parser-js';
import 'normalize-css/normalize.css';
import './App.css';

// export store as global for debugging
window.store = store;

// check for mobile OS
const parser = new UAParser();
store.dispatch( sniffAgent( parser.getDevice(), parser.getOS() ) );

// fetch App initialization JSON IF it has not been fetched
if(!store.getState().menu || !store.getState().menu.fetched){
	store.dispatch( fetchConfig() );
}

// React render (REF: react-snap documentation)
const rootElement = document.getElementById('root');
const body = (
	<Provider store={store}>
		<Router>
			<Route component={App} />
		</Router>
	</Provider>
);
if (rootElement.hasChildNodes()) {
	hydrate(body, rootElement);
	console.log('hydrating');
} else {
	render(body, rootElement);
}

export { body };



// WEBPACK FOOTER //
// ./src/index.js